// extracted by mini-css-extract-plugin
export default {"address":"_2Xxzw","field":"QdfRJ"};